import { CURRENCY } from 'src/types';

/**
 * What a rate's values measure. `currency` values are money (minor units of `currency`); the other units are
 * dimensionless numbers stored with four implied decimals - see `utils/units.ts` for the scales.
 */
export enum REFERENCE_RATE_UNIT {
    CURRENCY = 'currency',
    PERCENT = 'percent',
    COEFFICIENT = 'coefficient',
    POINTS = 'points',
}

/**
 * The value covering today, embedded in the rate's read response so a list can show the current
 * amount without a second request. Null when no value in the series covers today.
 */
export type ReferenceRateCurrentValue = {
    id: string;
    valid_from: string;
    valid_to: string | null;
    /** An integer in minor units of the rate's unit - see `utils/units.ts`. */
    amount: number;
};

export type ReferenceRate = {
    id: string;
    name: string;
    code: string;
    /** Cannot be changed once the rate has values. */
    unit: REFERENCE_RATE_UNIT;
    /** Set only when `unit` is `currency`. */
    currency: CURRENCY | null;
    description: string | null;
    is_active: boolean | null;
    tenant: string | null;
    current_value: ReferenceRateCurrentValue | null;
};
